// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type UpdateEpmMasterAllocationKeyMutationVariables = Types.Exact<{
  input: Types.UpdateEpmMasterAllocationKeyInput;
}>;

export type UpdateEpmMasterAllocationKeyMutation = { __typename?: 'Mutation' } & {
  updateEpmMasterAllocationKey: { __typename?: 'EpmMasterAllocationKeyOutput' } & Pick<
    Types.EpmMasterAllocationKeyOutput,
    'id'
  >;
};

export const UpdateEpmMasterAllocationKeyDocument = /*#__PURE__*/ gql`
    mutation updateEpmMasterAllocationKey($input: UpdateEpmMasterAllocationKeyInput!) {
  updateEpmMasterAllocationKey(input: $input) {
    id
  }
}
    `;
export type UpdateEpmMasterAllocationKeyMutationFn = Apollo.MutationFunction<
  UpdateEpmMasterAllocationKeyMutation,
  UpdateEpmMasterAllocationKeyMutationVariables
>;

/**
 * __useUpdateEpmMasterAllocationKeyMutation__
 *
 * To run a mutation, you first call `useUpdateEpmMasterAllocationKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpmMasterAllocationKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpmMasterAllocationKeyMutation, { data, loading, error }] = useUpdateEpmMasterAllocationKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEpmMasterAllocationKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEpmMasterAllocationKeyMutation,
    UpdateEpmMasterAllocationKeyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateEpmMasterAllocationKeyMutation, UpdateEpmMasterAllocationKeyMutationVariables>(
    UpdateEpmMasterAllocationKeyDocument,
    options,
  );
}
export type UpdateEpmMasterAllocationKeyMutationHookResult = ReturnType<typeof useUpdateEpmMasterAllocationKeyMutation>;
export type UpdateEpmMasterAllocationKeyMutationOptions = Apollo.BaseMutationOptions<
  UpdateEpmMasterAllocationKeyMutation,
  UpdateEpmMasterAllocationKeyMutationVariables
>;
